

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

require('components/xo-models/src/auth/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function ($rootScope, $log, $state, $Forbidden, $logger, $timeout, $interval) {

    // let errorCount = 0;


    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./js/lib/security.js
// module id = ./js/lib/security.js
// module chunks = 1